import { 
  REQUEST_CREATE_REVIEW,
  RECEIVE_CREATE_REVIEW,
  SUBMIT_REVIEW,
  RECEIVE_SUBMIT_REVIEW_RESPONSE,
  RESET_REVIEW_STATE,
  REQUEST_REVIEW_LIST,
  RECEIVE_REVIEW_LIST,
  RECEIVE_REVIEWS_ERROR,
  REQUEST_MORE_REVIEWS,
  RECEIVE_MORE_REVIEWS,
  SET_REVIEWS_TO_SHOW,
} from '../constants/actionTypes';

import {
  INITIAL_REVIEWS_TO_SHOW,
} from '../constants';

const INITIAL_STATE = {
  reviewInfo: {},
  reviewList: [],
  offset: 0,
  totalReviews: 0,
  avgRating: 0,
  reviewsToShow: INITIAL_REVIEWS_TO_SHOW,
  hasSubmitted: false,
  loading: true,
  loadingMore: false,
  message: '',
  error: null,
};

function reviewsReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case RESET_REVIEW_STATE: {
      return {
        ...state,
        message: '',
        loading: true,
        error: null,
        reviewInfo: {},
      };
    }
    case REQUEST_CREATE_REVIEW: {
      return {
        ...state,
        message: '',
        loading: true
      };
    }
    case RECEIVE_CREATE_REVIEW: {
      return {
        ...state,
        reviewInfo: action.response,
        loading: false,
      };
    }
    case REQUEST_REVIEW_LIST: {
      return {
        ...state,
        loading: true,
        offset: 0,
        error: null,
        reviewsToShow: INITIAL_REVIEWS_TO_SHOW,
      };
    }
    case RECEIVE_REVIEW_LIST: {
      return {
        ...state,
        loading: false,
        offset: action.response.reviews.length,
        reviewList: action.response.reviews,
        avgRating: action.response.summary.average_rating,
        totalReviews: action.response.summary.total_reviews,
      };
    }
    case REQUEST_MORE_REVIEWS: {
      return {
        ...state,
        loading: true,
      };
    }
    case RECEIVE_MORE_REVIEWS: {
      return {
        ...state,
        loading: false,
        offset: state.offset + action.response.reviews.length,
        reviewList: [
          ...state.reviewList,
          ...action.response.reviews,
        ],
      };
    }
    case SET_REVIEWS_TO_SHOW: {
      return {
        ...state,
        reviewsToShow: action.reviewsToShow,
      };
    }
    case RECEIVE_REVIEWS_ERROR: {
      return {
        ...state,
        error: action.error,
      };
    }
    case SUBMIT_REVIEW: {
      return {
        ...state,
        loading: true,
      };
    }
    case RECEIVE_SUBMIT_REVIEW_RESPONSE: {
      return {
        ...state,
        loading: false,
        message: action.message,
      };
    }
    default:
      return state;
  }
}

export default reviewsReducer;